import { HEARD_ABOUT_OPTIONS, HEARD_ABOUT_OTHER } from '../../lib/heardAbout'
import { authErrorTextClass, authInputClass, authInputErrorClass, authLabelClass } from './authTheme'

interface HeardAboutFieldProps {
  value: string
  detail: string
  onChange: (value: string) => void
  onDetailChange: (value: string) => void
  disabled?: boolean
  error?: string
  detailError?: string
  label: string
  placeholder: string
  detailPlaceholder: string
  optionLabel: (option: string) => string
}

export default function HeardAboutField({
  value,
  detail,
  onChange,
  onDetailChange,
  disabled,
  error,
  detailError,
  label,
  placeholder,
  detailPlaceholder,
  optionLabel,
}: HeardAboutFieldProps) {
  return (
    <div>
      <label htmlFor="heard_about" className={authLabelClass}>
        {label}
      </label>
      <select
        id="heard_about"
        name="heard_about"
        required
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        className={`mt-1 rounded-md ${authInputClass} ${error ? authInputErrorClass : ''}`}
      >
        <option value="">{placeholder}</option>
        {HEARD_ABOUT_OPTIONS.map((option) => (
          <option key={option} value={option}>
            {optionLabel(option)}
          </option>
        ))}
      </select>
      {error && <p className={authErrorTextClass}>{error}</p>}
      {value === HEARD_ABOUT_OTHER && (
        <input
          id="heard_about_detail"
          name="heard_about_detail"
          type="text"
          required
          maxLength={255}
          value={detail}
          onChange={(event) => onDetailChange(event.target.value)}
          disabled={disabled}
          placeholder={detailPlaceholder}
          className={`mt-2 rounded-md ${authInputClass} ${detailError ? authInputErrorClass : ''}`}
        />
      )}
      {detailError && <p className={authErrorTextClass}>{detailError}</p>}
    </div>
  )
}
